export default __webpack_public_path__ + "static/media/foodz.3e0212e0.png";